import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../Icon';
import { dismissNotification, selectNotifications } from 'features/ui/uiSlice';
import './Toast.css';

const ICONS = { success: 'check', error: 'alert', warning: 'alert', info: 'inbox' };

const Toast = ({ notification, onDismiss }) => {
  const { id, type = 'info', title, message, duration } = notification;

  useEffect(() => {
    if (!duration) return undefined;
    const timer = setTimeout(() => onDismiss(id), duration);
    return () => clearTimeout(timer);
  }, [id, duration, onDismiss]);

  return (
    <div className={`kvo-toast kvo-toast--${type}`} role="alert">
      <span className="kvo-toast__icon">
        <Icon name={ICONS[type] || 'inbox'} size={18} />
      </span>
      <div className="kvo-toast__content">
        {title && <p className="kvo-toast__title">{title}</p>}
        <p className="kvo-toast__message">{message}</p>
      </div>
      <button type="button" className="kvo-toast__close" onClick={() => onDismiss(id)} aria-label="Dismiss">
        <Icon name="close" size={14} />
      </button>
    </div>
  );
};

/** Global toast viewport. Mounted once at the app root. */
const ToastContainer = () => {
  const notifications = useSelector(selectNotifications);
  const dispatch = useDispatch();
  if (!notifications.length) return null;

  return createPortal(
    <div className="kvo-toast__viewport">
      {notifications.map((n) => (
        <Toast key={n.id} notification={n} onDismiss={(id) => dispatch(dismissNotification(id))} />
      ))}
    </div>,
    document.body
  );
};

export default ToastContainer;
